export default __webpack_public_path__ + "8b9c344847f9f646668e53fb37508b3b.jpeg";